export default __webpack_public_path__ + "480b945be5995c948a66d70e25fde7dc.ttf";